import React from 'react';
import { Link } from 'react-router-dom';
import  PageTitle from '../../Components/PageTitle';
import { images } from '../../assets/images';
import { routes } from '../../routes';

function Product() {
	return (
		<>
        <PageTitle title="Our Products" />
        <section className="products_section bg-light pt-5 pb-5">
            <div className="container">
                <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="products_area el">
                            <div className="products_items">
                                <div className="row ">
                                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                        <div className="product_item">
                                            <div className="product_img">
                                                <img src={images.prod1} alt="..." className="img-fluid d-block mx-auto" />
                                                <div className="upper_image">
                                                    <div className="secondary_btn text-center">
                                                        <Link to={routes.productdetail}>View Details <i className="far fa-angle-right"></i></Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="product_info">
                                                <h4>Product Name Here</h4>
                                                <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eos amet eius impedit placeat similique veniam adipisci libero quaerat voluptatum omnis.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                        <div className="product_item">
                                            <div className="product_img">
                                                <img src={images.prod2} alt="..." className="img-fluid d-block mx-auto" />
                                                <div className="upper_image">
                                                    <div className="secondary_btn text-center">
                                                        <Link to={routes.productdetail}>View Details <i className="far fa-angle-right"></i></Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="product_info">
                                                <h4>Product Name Here</h4>
                                                <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eos amet eius impedit placeat similique veniam adipisci libero quaerat voluptatum omnis.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                        <div className="product_item">
                                            <div className="product_img">
                                                <img src={images.prod1} alt="..." className="img-fluid d-block mx-auto" />
                                                <div className="upper_image">
                                                    <div className="secondary_btn text-center">
                                                        <Link to={routes.productdetail}>View Details <i className="far fa-angle-right"></i></Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="product_info">
                                                <h4>Product Name Here</h4>
                                                <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eos amet eius impedit placeat similique veniam adipisci libero quaerat voluptatum omnis.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                        <div className="product_item">
                                            <div className="product_img">
                                                <img src={images.prod1} alt="..." className="img-fluid d-block mx-auto" />
                                                <div className="upper_image">
                                                    <div className="secondary_btn text-center">
                                                        <Link to={routes.productdetail}>View Details <i className="far fa-angle-right"></i></Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="product_info">
                                                <h4>Product Name Here</h4>
                                                <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eos amet eius impedit placeat similique veniam adipisci libero quaerat voluptatum omnis.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                        <div className="product_item">
                                            <div className="product_img">
                                                <img src={images.prod1} alt="..." className="img-fluid d-block mx-auto" />
                                                <div className="upper_image">
                                                    <div className="secondary_btn text-center">
                                                        <Link to={routes.productdetail}>View Details <i className="far fa-angle-right"></i></Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="product_info">
                                                <h4>Product Name Here</h4>
                                                <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eos amet eius impedit placeat similique veniam adipisci libero quaerat voluptatum omnis.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
		</>
	);
}

export default Product;